import { api } from "@/lib/api-client"

import { LogoutResponse } from "../types/api"
import { LogoutRequest } from "../types/form"

export const logout = (data: LogoutRequest): Promise<LogoutResponse> => {
  return api.post("/auth/logout ", data)
}
